import { useAuth } from "../context/AuthContext";

export function useBuilderQuery() {
  const { isAdmin, isBuilder, builderScope } = useAuth();
  return {
    isAdmin,
    isBuilder,
    builderScope,
    query: isAdmin ? { builderId: builderScope } : {},
    ready: !isAdmin || Boolean(builderScope),
  };
}
